/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const SET_MACHINE_SEARCH_VALUE = 'SET_MACHINE_SEARCH_VALUE';
export const SET_MACHINE_CURRENT_SELECTION= 'SET_MACHINE_CURRENT_SELECTION';
export const SET_MACHINE_CURRENT_NAME= 'SET_MACHINE_CURRENT_NAME';
export const SET_MACHINE_CURRENT_SELECTED_TAB = 'SET_MACHINE_CURRENT_SELECTED_TAB';
